import { useAtom } from 'jotai'
import {
  useEntityFiltersBar,
  ActiveFilterPill,
  GreyGrey30,
  Flex
} from '@sequencehq/core-components'
import {
  watchtowerFiltersAtom,
  WatchtowerFilterType
} from 'Automations/watchtower/atoms'
import { WATCHTOWER_FILTER_CONFIGS } from 'Automations/watchtower/watchtowerFilterConfigs'
import { useFeatureFlags } from 'hooks/useFeatureFlags'

export const ExecutionFilterPills = () => {
  const flags = useFeatureFlags()
  const [selectedFilters, setSelectedFilters] = useAtom(watchtowerFiltersAtom)
  const filters = WATCHTOWER_FILTER_CONFIGS({
    useAutomationsDunning: flags.useAutomationsDunning
  })
  const { activeFilterPills, updateFilter, clearFilter } =
    useEntityFiltersBar<WatchtowerFilterType>({
      filters,
      selectedFilters,
      onFilterChange: setSelectedFilters
    })

  if (activeFilterPills.length === 0) return null

  return (
    <Flex
      gap="8px"
      alignItems="start"
      flexWrap="wrap"
      padding="8px 16px"
      borderBottom={`1px solid ${GreyGrey30}`}
    >
      {activeFilterPills.map(pill => (
        <ActiveFilterPill
          key={pill.filterType}
          {...pill}
          onChange={ids => updateFilter(pill.filterType, ids)}
          onClear={() => clearFilter(pill.filterType)}
        />
      ))}
    </Flex>
  )
}
